export default function ModalController($uibModalInstance) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        dismiss,
        close,
    });

    function dismiss() {
        $uibModalInstance.dismiss('cancel');
    }

    function close(callback) {
        if (callback) {
            callback();
        }
        $uibModalInstance.close('close');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/modal/modal-controller.js